import { render, staticRenderFns } from "./upload-model.vue?vue&type=template&id=4f0c5e2f&scoped=true&"
import script from "./upload-model.vue?vue&type=script&lang=ts&"
export * from "./upload-model.vue?vue&type=script&lang=ts&"
import style0 from "./upload-model.vue?vue&type=style&index=0&id=4f0c5e2f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c5e2f",
  null
  
)

export default component.exports